// Router
import { replace } from "react-router-redux";
import { BASE_URL } from "../../config/constants";
// API
import { put } from "../../services/api";
// Ducks
import {
  setProfile,
  setIsPasswordIntendedToChange,
  setIsProfileIntendedToApprove,
  USERNAME_KEY
} from "../../services/auth.ducks";
import { hideSpinner, showSpinner } from "../../services/spinner.ducks";
import { setErrorNotification } from "../../components/SmartNotification/SmartNotification.ducks";

// eslint-disable-next-line import/prefer-default-export
export const changeProfile = (profile) => async (dispatch, getState) => {
  try {
    const state = getState();
    const oldProfile = state.auth.profile;
    const newProfile = { ...oldProfile, ...profile };
    dispatch(showSpinner());
    const { data } = await dispatch(put(`/user`, newProfile));

    localStorage.setItem(USERNAME_KEY, `${data.firstName} ${data.lastName}`);

    dispatch(setProfile(data));
    dispatch(setIsPasswordIntendedToChange(data.isPasswordIntendedToChange));
    dispatch(setIsProfileIntendedToApprove(data.isProfileIntendedToApprove));
    dispatch(hideSpinner());
    dispatch(replace(`${BASE_URL}/dashboard`));
  } catch (err) {
    let message;

    if (err.response && err.response.data && err.response.data.message) {
      switch (err.response.data.message) {
        case `users.post.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `users.post.error.client.notFound`:
          message = `modules.localization.register.authenticated.error.client.notFound`;
          break;

        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }
    }

    dispatch(
      setErrorNotification({
        messageTranslationKey: message,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
      })
    );
    dispatch(hideSpinner());
  }
};
